var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-5"},[_c('v-switch',{attrs:{"inset":"","label":`Switch 1: ${_vm.switch1.toString()}`},on:{"change":_vm.toggleDarkTheme},model:{value:(_vm.switch1),callback:function ($$v) {_vm.switch1=$$v},expression:"switch1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }